<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { ConfigProvider } from 'tdesign-mobile-vue/es/config-provider'

import type { AppLocale } from '@/locales'

import { resolveTDesignLocale } from './tdesignLocale'

const { locale } = useI18n()
const globalConfig = computed(() => resolveTDesignLocale(locale.value as AppLocale))
</script>

<template>
  <ConfigProvider :global-config="globalConfig">
    <slot />
  </ConfigProvider>
</template>
